import { Typography } from "@mui/material";
import SupportTicketList from "components/SupportTickets/SupportTicketList";
import { SUPPORT_KEY, listSupportTickets, supportTicketPath } from "../supportTicketsApi";

/** This partner's tickets, open first; each opens the shared ticket page. */
const PartnerSupportPanel = ({ partnerId }) => (
  <div className="space-y-4">
    <div className="rounded-lg border border-app-border p-4">
      <Typography variant="subtitle1" className="font-semibold" sx={{ mb: 2 }}>
        Open tickets
      </Typography>
      <SupportTicketList
        queryKey={[...SUPPORT_KEY, "list", "OPEN", "partner", partnerId]}
        fetchPage={listSupportTickets}
        params={{ status: "OPEN", partnerId }}
        pageSize={5}
        linkTo={supportTicketPath}
        emptyText="No open tickets from this partner."
      />
    </div>
    <div className="rounded-lg border border-app-border p-4">
      <Typography variant="subtitle1" className="font-semibold" sx={{ mb: 2 }}>
        All tickets
      </Typography>
      <SupportTicketList
        queryKey={[...SUPPORT_KEY, "list", "ALL", "partner", partnerId]}
        fetchPage={listSupportTickets}
        params={{ status: "ALL", partnerId }}
        pageSize={10}
        linkTo={supportTicketPath}
        emptyText="This partner has not opened any tickets."
      />
    </div>
  </div>
);

export default PartnerSupportPanel;
